import { HiddenSectionEmailsModel } from '../../models/hiddenSectionEmails';
import ApiClient from '../ApiClient';
import { NiceResponse } from '../dto/NiceResponse';

export class HiddenSectionEmailsApi {
  // eslint-disable-next-line no-unused-vars
  constructor(private api: ApiClient) {}

  path = '/hidden-section-emails';

  async create(req: {
    email: string;
    platform_ios: boolean;
    platform_android: boolean;
  }) {
    const resp = await this.api.client.post<NiceResponse<null>>(
      this.path + '/create',
      req,
    );
    return resp.data;
  }

  async update(
    req: { platform_ios?: boolean; platform_android?: boolean },
    id: string,
  ) {
    const resp = await this.api.client.put<NiceResponse<null>>(
      this.path + '/update/' + id,
      req,
    );
    return resp.data;
  }

  async delete(id: string) {
    const resp = await this.api.client.delete<NiceResponse<null>>(
      this.path + '/delete/' + id,
    );
    return resp.data;
  }

  async get(skip: number, take: number) {
    const resp = await this.api.client.get<
      NiceResponse<HiddenSectionEmailsModel[]>
    >(this.path + '/list?skip=' + skip + '&take=' + take);
    return resp.data;
  }
}
